module.exports = __webpack_public_path__ + "static/fibre_network-81a0a43999efe4033362732576632c4f.jpg";